import { NewOpportunity } from '../../lib/types'

/** Convert admin-typed major currency units to integer cents. Empty/null stays null. */
export const majorUnitsToCents = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null
  const n = Number(value)
  if (!Number.isFinite(n)) return null
  return Math.round(n * 100)
}

/** Convert stored cents to major currency units for form display. Empty/null stays null. */
export const centsToMajorUnits = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null
  const n = Number(value)
  if (!Number.isFinite(n)) return null
  return n / 100
}

const convertReferenceValuationAmount = (
  referenceValuation: NonNullable<NewOpportunity['metadata']['reference_valuation']>,
  convertAmount: (value: unknown) => number | null,
): NonNullable<NewOpportunity['metadata']['reference_valuation']> => ({
  ...referenceValuation,
  amount: convertAmount(referenceValuation.amount),
})

/** GET returns cents; divide so the admin form shows major units. */
export const convertOpportunityMoneyFieldsFromCents = (
  opportunity: NewOpportunity,
): NewOpportunity => {
  const referenceValuation = opportunity.metadata?.reference_valuation

  return {
    ...opportunity,
    ticket_size: centsToMajorUnits(opportunity.ticket_size) ?? 0,
    raise_goal: centsToMajorUnits(opportunity.raise_goal),
    metadata: opportunity.metadata
      ? {
          ...opportunity.metadata,
          reference_valuation: referenceValuation
            ? convertReferenceValuationAmount(referenceValuation, centsToMajorUnits)
            : referenceValuation ?? null,
        }
      : opportunity.metadata,
  }
}

/** Convert form major units to cents for POST/PATCH. Does not FX-convert currencies. */
export const convertOpportunityMoneyFieldsToCents = (
  opportunity: NewOpportunity,
): NewOpportunity => {
  const referenceValuation = opportunity.metadata?.reference_valuation

  return {
    ...opportunity,
    ticket_size: majorUnitsToCents(opportunity.ticket_size) ?? 0,
    raise_goal: majorUnitsToCents(opportunity.raise_goal),
    metadata: opportunity.metadata
      ? {
          ...opportunity.metadata,
          reference_valuation: referenceValuation
            ? convertReferenceValuationAmount(referenceValuation, majorUnitsToCents)
            : referenceValuation,
        }
      : opportunity.metadata,
  }
}
